var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVariant3 = function SvgVariant3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 172 172"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#variant3_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 72,
    fill: "#00A19A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 69.204,
    stroke: "#EFE6CC",
    strokeWidth: 5.592
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#variant3_svg__b)",
    d: "M33.764 36.345C6.352 65.165 7.502 110.758 36.32 138.17c28.82 27.412 74.413 26.281 101.825-2.538s26.261-74.413-2.558-101.824-74.413-26.28-101.824 2.538",
    opacity: 0.3,
    style: {
      mixBlendMode: "hard-light"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "variant3_svg__b",
    x1: 62.5,
    x2: -7.427,
    y1: -21.5,
    y2: 106.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36363A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#3B3B3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#4B4B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#656568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#89898B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#B7B7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#DBDBDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C5C5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#A1A1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#6F6F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5F5F63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#636367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#707074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#878789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#98989A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#A5A5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C7C7C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#848487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#38383D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B20"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "variant3_svg__a",
    width: 144.699,
    height: 144.699,
    x: 14,
    y: 14,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.699,
    dy: 0.699
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_892_180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_892_180",
    result: "shape"
  })))));
};
export default SvgVariant3;